const photoItem = {
    props: {
        card: {
            type: Object,
            default() {
                return null;
            },
        }
    },
    template: 
    `<div class="b-photo-item" :style="{ backgroundImage: 'url(' + cardBg + ')' }">
        <a :href="card.url" class="b-photo-item__wrap">
            <div class="b-photo-item__conts">
                <div class="b-photo-item__date" v-if="card.date && card.date !==''" v-html="card.date"></div>
                <div class="b-photo-item__title" v-if="card.title && card.title !==''" v-html="card.title"></div>
                <div class="b-photo-item__desc" v-if="card.desc && card.desc !==''" v-html="card.desc"></div>
            </div>
        </a>
    </div>`,
    computed: {
        cardBg() {
            if (this.card !== null && this.card.thumb && this.card.thumb !== "") {
                return this.card.thumb;
            }
            return "";
        }
    }
};
